//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import QAuModelTreeItemLight from "./qAuModelTreeItemLight";
import DataModel from "../../UserInterfaces/mixins/datamodel-utils";

export default {
    name: "QAuModelTreeLight",
    components: { QAuModelTreeItemLight },
    mixins: [DataModel],
    provide() {
        const tree = {};

        Object.defineProperty(tree, "expanded", { enumerable: true, get: () => this.expanded });

        return { tree };
    },
    props: {
        data: { type: Array }
    },
    data() {
        return {
            doneLoading: false,
            expanded: []
        };
    },
    computed: {
        ...mapState("components", ["parsed"]),
        nodes() {
            return this.generateNodeList(this.data);
        }
    },
    methods: {
        ...mapActions("components", ["getDataModelLatestVersion"]),
        loadDataModel() {
            return new Promise(resolve => {
                let dataModel; let
                    externalModel;

                this.getDataModelLatestVersion().then(() => {
                    dataModel = new Promise(resolve => {
                        this.getRawDataModel().then(() => {
                            this.parseCatalogsRawData();
                            this.parseModelClassesRawData();
                            resolve();
                        });
                    });

                    externalModel = new Promise(resolve => {
                        Promise.all([this.getRawExternalAPIs(), this.getRawSystemVariables()])
                            .then(([rawExternalAPIs, rawSystemVariables]) => {
                                this.parseAPIsRawData(rawExternalAPIs);
                                this.parseSystemVariables(rawSystemVariables);
                                resolve();
                            });
                    });

                    Promise.all([dataModel, externalModel]).then(() => {
                        resolve();
                    });
                });
            });
        },
        codeToParsed(code) {
            let source = null;

            switch (code) {
                case "m": { source = this.parsed.modelClasses; break; }
                case "c": { source = this.parsed.catalogs; break; }
                case "s": { source = this.parsed.systemVariables; break; }
            }

            return source;
        },
        generateNodeList(data) {
            const nodeList = [];

            (data || []).forEach(item => {
                let parsedData; let itemList; let cursor;
                let source = nodeList; const
                    path = [];

                if (item.charAt(1) === "_") {
                    parsedData = this.codeToParsed(item.charAt(0));
                    item = item.substring(2);
                } else {
                    parsedData = this.parsed.modelClasses;
                }

                itemList = item.split(".");
                while ((cursor = itemList.splice(0, 1)).length) {
                    let key; let node; const
                        label = cursor[0];

                    path.push(label);
                    key = path.join(".");
                    node = source.find(entry => entry.key === key);

                    if (node) {
                        source = node.children;
                    } else {
                        const newNode = { key, label, children: [] };
                        this.findDetails(newNode, parsedData);

                        source.push(newNode);
                        source = newNode.children;
                    }
                }
            });

            return nodeList;
        },
        findDetails(node, source) {
            const nodeList = node.key.split("."); let
                cursor;

            if (nodeList.length > 1) {
                cursor = source[nodeList.splice(0, 1)[0]] || null;
                if (cursor) {
                    nodeList.forEach(nodeItem => {
                        cursor = cursor.fields[nodeItem];
                    });

                    node.attrType = cursor.type + (cursor.isList ? " [ ]" : "");
                    node.hasChildren = cursor.fields;
                    node.isList = cursor.isList;
                }
            }
        }
    },
    beforeMount() {
        const waitPromise = this.parsed.firstTime ? this.loadDataModel() : Promise.resolve(true);

        waitPromise.then(() => {
            this.doneLoading = true;
        });
    }
};
